// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../assets/stylesheets/variables.css\"","paddedForNavbar":"_15-uIrn7gODHiOpUuDWjwC","title":"_2AQjRJzwe65aWgCDc_Ds2m _2IbHD4FVxtBnbNHEUw2mS3","genericContainer":"_2ELtkcMpIJZ1yyH_kfj3I7","mobileThreshold":"575px","container":"UGC3Pbv_1fJN8vFjaDOex _15-uIrn7gODHiOpUuDWjwC","mainContent":"_18UV6eUpL3YTywJQ8hNdm3 _2ELtkcMpIJZ1yyH_kfj3I7","form":"_33OrX7LQTI2oSPbehoacAW"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/change-password/ChangePassword.css
// module id = 685
// module chunks = 0